// extracted by mini-css-extract-plugin
export default {"container":"AppTextArea_container__FZQoc","count":"AppTextArea_count__mpSn4","input":"AppTextArea_input__fEJOk"};